import { Flex } from '@chakra-ui/react'

import { useGetMeetingBookedDataQuery } from '../api'
import { Granularity, MeetingData, TimeFrame } from '../types'
import AverageTimeToMeet from './AverageTimeToMeet'
import MeetingBookedRate from './MeetingBookedRate'
import MeetingsBookedHeatmap from './MeetingsBookedHeatmap'
import MeetingsScheduled from './MeetingsScheduled'

type Props = {
	allMeetings: MeetingData[] | undefined
	granularity: Granularity
	datePreset: TimeFrame
	isLoadingAllMeetings: boolean
}

export const MeetingAnalytics = ({
	allMeetings,
	granularity,
	datePreset,
	isLoadingAllMeetings = false,
}: Props) => {
	const { data: meetingsBookedData, isLoading: isMeetingsBookedLoading } =
		useGetMeetingBookedDataQuery({
			datePreset,
		})

	return (
		<Flex direction="column" gap={6} justifyContent="space-between">
			<AverageTimeToMeet
				meetings={allMeetings}
				granularity={granularity}
				datePreset={datePreset}
				isLoadingAllMeetings={isLoadingAllMeetings}
			/>

			<MeetingsScheduled
				meetings={allMeetings}
				granularity={granularity}
				isLoading={isLoadingAllMeetings}
			/>

			<MeetingBookedRate
				rawData={meetingsBookedData}
				granularity={granularity}
				datePreset={datePreset}
				isLoading={isMeetingsBookedLoading}
			/>

			<MeetingsBookedHeatmap
				granularity={granularity}
				datePreset={datePreset}
			/>
		</Flex>
	)
}
